import { useContent } from 'src/contexts/ContentContext';
import { PosDropdown } from 'src/core/POS/PosDropdown';
import { vars } from 'src/core/themes';
import { IconsFill, MoreIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import { ExportPaymentLinesAction } from './ExportPaymentLinesAction';

export const MarketplacePaymentsDetailsDropdown = ({
  marketplacePaymentId,
}: {
  marketplacePaymentId?: number;
}) => {
  const actionsMsg = useContent(ContentId.Actions);
  if (!marketplacePaymentId) {
    return null;
  }
  return (
    <>
      <PosDropdown
        key="payments-action-dropdown"
        trigger={
          <div
            title={actionsMsg}
            style={{ padding: `0 ${vars.spacing.sm} 0 ${vars.spacing.xxs}` }}
          >
            <MoreIcon
              withHoverEffect
              fill={IconsFill.textBrand}
              align="middle"
            />
          </div>
        }
        align="end"
      >
        <ExportPaymentLinesAction marketplacePaymentId={marketplacePaymentId} />
      </PosDropdown>
    </>
  );
};
